module.exports = __webpack_public_path__ + "static/img/brand9.94e5951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand9.png
// module id = /qFy
// module chunks = 1